// --------------------------------------------------------
// ---------------TRD Subseries ------------------------------
// --------------------------------------------------------

import {
  setErrorMsg,
  setSuccessMsg,
  uiCloseModalAdd,
  uiCloseModalEdit,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
} from "../../../../redux/actions/uiActions";
import {
  ITrdAction,
  ITrdDocumentalType,
  ITrdSubSerie,
  ITrdVersion,
  Types,
} from "../../../../redux/types/types";
import {
  addOrUpdateSubserie, checkIfSubserieUsedInCorrespondence,
  deleteSubserieFirebase,
  existsSubserie,
  loadSubseries,
  updateArraySubseries,
} from "../../firebase/subSerieService";

import { addOrEditTrdVersion } from "./trdActions";

// Activar Subserie
export const setActiveSubserie = (subSerie: ITrdSubSerie | null) => ({
  type: Types.setActiveSubserie,
  payload: subSerie,
});

const deleteSubserie = (idSubserie: string) => ({
  type: Types.deleteSubserie,
  payload: idSubserie,
});
// setear subseries
export const setSubseries = (subSeries: ITrdSubSerie) => ({
  type: Types.loadSubseries,
  payload: subSeries,
});

const addSubSerie = (trdSubserie: ITrdSubSerie): ITrdAction => ({
  type: Types.addSubserie,
  payload: trdSubserie,
});

const updateSubserie = (trdSubserie: ITrdSubSerie) => ({
  type: Types.updateTrdSubserie,
  payload: trdSubserie,
});

export const startDeleteSubSerie = (idSubserie: string) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { versions, activeSubSerie, documentalType } = getState().trd;
    let newSubseries: string[] = [];

    const versionFiltered = versions.filter(
      (ver: ITrdVersion) => ver.idVersion === activeSubSerie.idVersion
    )[0];

    // Verificar si no se han creado tipos documental
    const documentalTypeBySubserieCode = documentalType.filter(
      (doc: ITrdDocumentalType) =>
        doc.subSerieCode === activeSubSerie.subSerieCode
    );

    const isSubserieUsedInCorrespondence = await checkIfSubserieUsedInCorrespondence(idEntity, activeSubSerie.idSubserie);

    if (isSubserieUsedInCorrespondence) {
      dispatch(setErrorMsg("ErrorDeleteSubserieByCorrespondence"));
      dispatch(uiOpenErrorAlert());
    } else if(documentalTypeBySubserieCode.length > 0) {
      dispatch(setErrorMsg("ErrorDeleteSubserieByCorrespondence"));
      dispatch(uiOpenErrorAlert());
    }
    else {
      versionFiltered &&
        (newSubseries = versionFiltered.subseries.filter(
          (el: string) => el !== idSubserie
        ));

      const { ok } = await deleteSubserieFirebase(
        idEntity,
        activeSubSerie.idSerie,
        idSubserie
      );
      const { ok: okUpdated } = await updateArraySubseries(
        idEntity,
        activeSubSerie.idVersion,
        newSubseries
      );

      if (ok && okUpdated) {
        dispatch(deleteSubserie(idSubserie));
        dispatch(
          addOrEditTrdVersion({
            ...versionFiltered,
            subseries: newSubseries,
          })
        );
        dispatch(setSuccessMsg("SuccesDeleteSubserie"));
        dispatch(uiOpenSuccessAlert());
      } else {
        dispatch(setSuccessMsg("ErrorDeleteSubserie"));
        dispatch(uiOpenErrorAlert());
      }
    }
  };
};

// Cargar subseries
export const startLoadingSubseries = (idEntity: string) => {
  return async (dispatch: Function) => {
    const subSeries = await loadSubseries(idEntity);

    if (subSeries) {
      dispatch(setSubseries(subSeries));
    }
  };
};

export const startAddOrEditSubserie = (subserie: ITrdSubSerie) => {
  return async (dispatch: Function, getState: Function) => {
    const { idEntity } = getState().auth.user;
    const { versions, activeSubSerie } = getState().trd;
    const { idVersion, idSerie } = subserie;
    let newSubSeries: string[] = [];

    const existsSubseries = await existsSubserie(
      idEntity,
      idVersion,
      idSerie,
      subserie.subSerieCode,
      subserie.name,
      !!activeSubSerie
    );

    if (existsSubseries.length > 0) {
      dispatch(setSuccessMsg("ExistsSubserie"));
      dispatch(uiOpenErrorAlert());
    } else {
      if (activeSubSerie) {
        const { ok } = await addOrUpdateSubserie(idEntity, idSerie, subserie);
        if (ok) {
          dispatch(updateSubserie(subserie));
          dispatch(setSuccessMsg("SubSerieUpdated"));
          dispatch(uiCloseModalEdit());
          dispatch(setActiveSubserie(null));
          dispatch(uiOpenSuccessAlert());
        } else {
          dispatch(uiOpenErrorAlert());
          dispatch(setSuccessMsg("ErrorSubserieUpdate"));
        }
      } else {
        // CREAR SubSerie
        // Consultar array de oficinas productoras, series y versiones en TRD
        const versionFiltered = versions.filter(
          (ver: ITrdVersion) => ver.idVersion === idVersion
        )[0];

        subserie.idSubserie = `${subserie.subSerieCode}_${Date.now()}`;
        subserie.provision = {
          CT: subserie.provision.CT,
          E: subserie.provision.E,
          MD: subserie.provision.MD,
          S: subserie.provision.S,
        };
        newSubSeries = versionFiltered.subseries
          ? [...versionFiltered.subseries, subserie.idSubserie]
          : [subserie.idSubserie];
        // Agregar a colección subseries
        const { ok } = await addOrUpdateSubserie(idEntity, idSerie, subserie);
        const { ok: updated } = await updateArraySubseries(
          idEntity,
          idVersion,
          newSubSeries
        );
        if (ok && updated) {
          dispatch(setSuccessMsg("SubSerieCreated"));
          dispatch(uiCloseModalAdd());
          dispatch(uiOpenSuccessAlert());
          dispatch(addSubSerie(subserie));
          dispatch(
            addOrEditTrdVersion({
              ...versionFiltered,
              subseries: newSubSeries,
            })
          );
        } else {
          dispatch(setSuccessMsg("ErrorSubserieCreate"));
          dispatch(uiOpenErrorAlert());
        }
      }
    }
  };
};
